import * as React from 'react'

import {Button, Form} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
import {KixGbcInformationStore, InformationItem} from "../../store/InformationStore";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import appStyles from '../../assets/css/app.scss';
import {FastlaneService} from "../../service/FastlaneService";
import {redirect} from "../../../src/common/Router/routerCommon";
import {getRouteParam} from "../../../src/utils/react/routerUtil";

@observer
class Member extends ViewBaseComponent<{} & FormComponentProps, {}> {
  informationStore: KixGbcInformationStore | undefined;
  formUtils = this.props.form;
  fastLaneService = new FastlaneService(this.formUtils, 1);
  loungeService = new FastlaneService(this.formUtils, 2);

  componentWillMount() {
    this.informationStore = new KixGbcInformationStore();
    const id = Number(getRouteParam("id"));

    loginUserStore.getLoginUser().then(() => {
      this.informationStore!.getList(0, 100, id);
      // 既読にする
      this.informationStore!.markAsRead(id);
    });
  }

  componentWillUnmount() {
    this.informationStore = void 0
  }

  editText(text: any) {
    const regExp = /(https?:\/\/\S+|\n)/;
    const regExpBr = /\n/;
    const regExpLink = /https?:\/\/\S+/;
    return text.split(regExp).map(function (line: any,i: any) {
      return line.match(regExpBr)
        ? (<br key={i} />)
        : line.match(regExpLink)
          ? (<a target="_blank" href={line} key={i}>{line}</a>)
          : line
    });
  }

  render() {
    // const regex = /([\n\r])/g;
    // const nl2br = (str: any) => {
    //   return str.split(regex).map((line: any) => {
    //     return line.match(regex) ? <br/> : line
    //   })
    // };

    return (
      <KixGbcMemberLayout>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>お知らせ</h2>

        {this.informationStore!.list!.map((value) => {
          return <>
            <div style={{marginTop: "1.5em", borderBottom: "1px solid white"}}>
              <p className={appStyles.h3White} style={{fontSize: "1em"}}>{value.publish_dt}</p>
              <p className={appStyles.h3White} style={{marginBottom: 0}}>{value.title}</p>
            </div>
            <div style={{overflowY: "auto", maxHeight: "10em", marginBottom: "3em"}}>
              <div className={appStyles.textWhite}
                   style={{marginBottom: 0, borderBottom: "1px dashed white", padding: "2em 0 2em 0"}}
                   key={value.id}>
                <span>{this.editText(value.body)}</span>
              </div>

            </div>
          </>
        })}

        <div style={{margin: "1em 0 3em 0", fontSize: "0.8em"}} className={commonStyles.fCenter}>
          <Button onClick={() => redirect("/")} size={"large"} className={`${appStyles.buttonDeepBlue}`}
                  style={{color: "white", padding: "0 2em 0 2em", height: "3.5em", marginRight: "1em"}}>
            GBC会員専用TOPへ
          </Button>
        </div>
      </KixGbcMemberLayout>
    );
  }
}

export default Form.create()(Member)

